import { LocalStorageApi } from '@shared/lib';

export const tokenStorage = new LocalStorageApi('access-token');
